var r={SUCCESS:"success",ERROR:"error",WARNING:"warning",INFO:"info"};export{r as TimelineVariant};
//# sourceMappingURL=types.js.map
